import React, { lazy, Suspense, useEffect } from "react";
import {
  Route,
  Navigate,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { Loader, BusinessInfo, EditTemplate } from "@components";
import ErrorBoundary from "./ErrorBoundary";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "../route.constants";
import { useSelector } from "react-redux";
import { localStorage } from "@utils";
import PayHostingFee from "../components/TemplateManagement/PayHostingFee/PayHostingFee";
import BestSellingProducts from "../components/Dashboard/BestSellingProducts";
import OrderDetails from "../components/TemplateManagement/PayHostingFee/HostingFeeOrderDetails/OrderDetails";
import NotiDetails from "../components/TemplateManagement/Settings/Notifications/NotiDetails";

const Home = lazy(() => import("@pages/Home/Home"));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import("@pages/Login/Login")),
  },
  {
    path: PUBLIC_ROUTE.LOGIN,
    exact: true,
    component: lazy(() => import("@pages/Login/Login")),
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import("@pages/404/404")),
  },
  {
      path: PUBLIC_ROUTE.ORDER_VOUCHER,
      component: lazy(() =>
        import("@components/OrderManagement/OrderVouncher/Vouncher")
      ),
      exact: true,
    },
];

const PrivateRoute = ({ children }) => {
  const isLoggedIn =
    useSelector((state) => state.auth.token) || localStorage.getToken();
  const isNewUser = useSelector((state) => state.auth.isNewUser);

  if (isNewUser) {
    return <Navigate to={`/${PRIVATE_ROUTE.BUSINESS_INFO}`} replace={true} />;
  } else if (!isLoggedIn) {
    return <Navigate to={PUBLIC_ROUTE.LOGIN} replace={true} />;
  }

  return children;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <ScrollToTop />
          <Routes>
            {publicRoutes.map((route, index) => (
              <Route
                key={index}
                exact={route.exact}
                path={route.path}
                element={<route.component />}
              />
            ))}
            <Route
              exact
              path={PRIVATE_ROUTE.BUSINESS_INFO}
              element={<BusinessInfo />}
            />
            <Route
              exact
              path={`/${PRIVATE_ROUTE.HOME}/*`}
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path={`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.DASHBOARD}/${PRIVATE_ROUTE.BEST_SELLING_PRODUCTS}`}
              element={<BestSellingProducts />}
              />
              <Route
              exact
              path={`/${PRIVATE_ROUTE.HOME}/orderDetails/:id`}
              element={
                <PrivateRoute>
                  <OrderDetails />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path={`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.NOTIFICATION}/details/:id`}
              element={
                <PrivateRoute>
                  <NotiDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.TEMPLATE_MGNT}/${PRIVATE_ROUTE.EDIT_TEMPLATE}`}
              element={<EditTemplate />}
            />
            <Route
              path={`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.TEMPLATE_MGNT}/${PRIVATE_ROUTE.EDIT_TEMPLATE}/${PRIVATE_ROUTE.PAY_HOSTING_FEE}`}
              element={<PayHostingFee />}
            />
            <Route path="*" element={<Navigate to={PUBLIC_ROUTE.PAGE_404} />} />
          </Routes>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
};

export default AppRoutes;
